module.exports = __webpack_public_path__ + "static/media/1-ball.585aa91e.png";